import {RoomCall} from "@/core/api/room.call.api";
import {RoomCallP2P} from "@/core/api/room.call.p2p.api";
import {RoomCallMixer} from "@/core/api/room.call.mixer.api";
import {RoomUser} from "@/core/api/room.user.api";

export default {
    devices: async ({ dispatch, commit, getters, rootGetters }) => {
        return await RoomCall.getUserDevices();
    },
    openLogMonitorPage: ({ dispatch, commit, getters, rootGetters }, data) => {
        window.open(RoomCall.Log.getLogMonitorUrl(), '_grm_packet_log_monitor_');
    },
    showConnectionStats: ({ dispatch, commit, getters, rootGetters }, data) => {
        commit('showConnectionStats', data);
    },
    hideConnectionStats: ({ dispatch, commit, getters, rootGetters }, data) => {
        commit('hideConnectionStats', data);
    },
    toggleConnectionStats: ({ dispatch, commit, getters, rootGetters }, data) => {
        commit('toggleConnectionStats', data);
    },
    changeVideoLayout: ({ dispatch, commit, getters, rootGetters }, data) => {
        RoomCall.Layout.changeVideoLayout(data);
    },

    getLocalDeviceSetting: ({ dispatch, commit, getters, rootGetters }) => {
        return RoomCall.Stream.getLocalDeviceSetting();
    },
    saveLocalDeviceSetting: ({ dispatch, commit, getters, rootGetters }, data) => {
        return RoomCall.Stream.setLocalDeviceSetting(data);
    },
    getUserVideoStream: async ({ dispatch, commit, getters, rootGetters }, params) => {
        const stream = RoomCall.getUserVideoStream({userId: params?.userId});
        return stream;
    },
    getUserScreenStream: async ({ dispatch, commit, getters, rootGetters }, { userId }) => {
        const stream = await RoomCall.getUserSecondStream({userId});
        return stream;
    },
    resizeMergedStream: ({ dispatch, commit, getters, rootGetters }, data) => {
        return RoomCall.resizeMergedStream(data);
    },    
    moveMergedStream: ({ dispatch, commit, getters, rootGetters }, data) => {
        return RoomCall.moveMergedStream(data);
    },
    updateMergedScreenStream: ({ dispatch, commit, getters, rootGetters }) => {
        return RoomCall.updateMergedScreenStream();
    },
    getStreamMergerMatrix: ({ dispatch, commit, getters, rootGetters }) => {
        return RoomCall.getStreamMergerMatrix();
    },
    changeVideoQuality: async ({ dispatch, commit, getters, rootGetters }, videoQuality) => {
        return RoomCall.changeVideoQuality(videoQuality);
    },
    changeWebinarType: async ({ dispatch, commit, getters, rootGetters }, webinarType = 'none') => {
        return RoomCall.changeWebinarType(webinarType);
    },

    changeUserDevice: ({ dispatch, commit, getters, rootGetters }, {deviceType, deviceId}) => {
        RoomCall.changeUserDevice({deviceType, deviceId});
    },

    getVideoOnlyStream: ({ dispatch, commit, getters, rootGetters }, {stream}) => {
        if(!stream){
            return null;
        }
        if(stream._v_only_stream){
            return stream._v_only_stream;
        }

        const v_stream = stream._v_only_stream = new MediaStream(stream.getVideoTracks());
        v_stream._ori_stream = stream;

        ['add', 'remove'].forEach(type => {
            stream[`__ori__${type}__track`] = stream[`${type}Track`];
            stream[`${type}Track`] = track => {
                stream[`__ori__${type}__track`].call(stream, track);

                if(!stream._v_only_stream || track.kind !== 'video') return;
                stream._v_only_stream[`${type}Track`](track);
            }
        });

        return v_stream;
    },
    changeWallModeTargetScreen: async ({ dispatch, commit, getters, rootGetters }, data) => {
        if (!data?.targetScreen) {
            data = { targetScreen: 'grid' }
        }
        await RoomCallMixer.changeWallModeTargetScreen(data);
    },

    getP2PUserCurrentConnectionStats: async ({ dispatch, commit, getters, rootGetters }, userId) => {
        return RoomCallP2P.getUserCurrentConnectionStats(userId);
    },

    pauseMyVideo: async ({ dispatch, commit, getters, rootGetters }, options) => {
        return RoomCall.pauseMyVideo(options);
    },
    resumeMyVideo: async ({ dispatch, commit, getters, rootGetters }) => {
        return RoomCall.resumeMyVideo();
    },

    changeVideoSenderMaxBitrateFromDomElement: async ({ dispatch, commit, getters, rootGetters }, data) => {
        const {el, userId, videoWidth, videoHeight, bitrate, framerate} = data;
        const isMe = RoomUser.isMe(userId);
        const main = RoomCall._videoSenderBitrateMap = RoomCall._videoSenderBitrateMap || {
            user: new Map(),
            dom: new Map(),
        };

        const getSortedArr = arr => {
            return arr.concat().sort((a,b) => b.bitrate - a.bitrate);
        }

        const removeDom = (el, withoutUser) => {
            if(!el) return;
            let bUserId = main.dom.get(el);
            main.dom.delete(el);

            if(withoutUser === true) return;
            let arr = main.user.get(bUserId);
            if(arr){
                let sortArr = getSortedArr(arr);
                let maxData = sortArr[0];
                let isMaxData = false;
                arr.forEach((d, idx) => {
                    if(d.el !== el) return;
                    if(maxData){
                        if(d.bitrate >= maxData.bitrate){
                            isMaxData = true;
                        }
                    }
                    arr.splice(idx, 1);
                });
                if(isMaxData && arr.length > 0){
                    let maxData = getSortedArr(arr)[0];
                    // console.log('@@@ remove-setMaxData :[%s]isMe[%s]', logKey, isMe, maxData);
                    if(maxData){
                        RoomCall.changeVideoSenderMaxBitrate(maxData);
                    }
                }
            }
        }
        if(main.dom.has(el)){
            let bUserId = main.dom.get(el);
            if(bUserId !== userId){
                // console.log('@@@ remove diff dom :[%s]isMe[%s]', logKey, isMe, el, userId, videoWidth, videoHeight, bitrate, framerate);
                removeDom(el);
            }
            if(!el.isConnected){
                removeDom(el);
            }
        }

        // console.log('@@@ 1 :[%s]isMe[%s]', logKey, isMe, el, userId, videoWidth, videoHeight, bitrate, framerate);
        let send = true;
        let arr = main.user.get(userId);
        if(arr && arr.length > 0){
            // gc
            arr.forEach((item, idx, list) => {
                let remove = false;
                if(!item.el || !item.el.isConnected){
                    // console.log('@@@ remove-gc disconnect :[%s]isMe[%s]diss[%s]', logKey, isMe, item.el.isConnected, item);
                    remove = true;
                }
                if(!remove) return;
                list.splice(idx, 1);
                removeDom(item.el, true);
            });

            // max 내림차순 정렬
            let sortArr = getSortedArr(arr);
            // max data
            let maxData = sortArr.shift();
            if(maxData && maxData.el === el){ // max el 과 같을 경우
                let idx = arr.findIndex(d => d===maxData);
                arr.splice(idx, 1);
                if(
                    bitrate < maxData.bitrate
                    || framerate < maxData.framerate
                ){
                    // 작으면 다음 최대 값 조회
                    let nextMaxData = sortArr.find(nd => nd.bitrate > bitrate);
                    if(nextMaxData){
                        // console.log('@@@ nextData ', nextMaxData, data);
                        data = nextMaxData;
                    }
                }
            }else if(maxData && bitrate <= maxData.bitrate){ // max 값보다 작을 경우 max 를 유지한다.
                // if(!isMe){
                //     console.log('@@@ 1.1 ', maxData, bitrate);
                // }
                send = false;
            }
        }else if(!arr){
            arr = [];
        }

        if(bitrate > 0){
            arr.push(data);
            main.user.set(userId, arr);
            main.dom.set(el, userId);
        }
        if(arr.length === 0){
            main.user.delete(userId);
            main.dom.delete(el);
        }

        // if(!isMe){
        //     console.log('@@@ 2 send[%s]', send, el, userId, videoWidth, videoHeight, bitrate, framerate);
        // }
        if(!isMe && send){
            RoomCall.changeVideoSenderMaxBitrate(data)
        }
    },

}
